import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from '../shared/shared-components/shared.components.module';
import { SearchPageComponent } from './search-page.component';
import { SearchService } from './search.service';
@NgModule({
  declarations: [SearchPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedComponentsModule,
    TranslateModule
  ],
  providers: [SearchService],
  exports: [SearchPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SearchPageModule {}
